import React from 'react';
import { Heading, Text, Flex, Spacer, colors } from '@badi/badi-components';
import { translate } from 'base/shared/Localization';
import { getPublicAsset } from 'base/shared/Utils';
import Image from 'components/Image/Image';

const BadiPlusListingDetails = ({ room, userRole }) => {
  return (
    <Spacer top={2}>
      {['item_1', 'item_2', 'item_3', 'item_4', 'item_6'].map((item) => {
        return (
          <Spacer bottom={3} key={item}>
            <Flex justify="flexStart">
              <Spacer right={2}>
                <Image
                  alt="badiplus"
                  styles={{ width: '46px ', height: 'auto' }}
                  src={getPublicAsset(`/icons/badiplus-checkout/sidebar_${item}.svg`)}
                />
              </Spacer>
              <Spacer>
                <Text body={2}>
                  {translate(`recovery.badi_plus_payment_checkout_sidebar_${item}.title`)}
                </Text>
                <Text body={6}>
                  {translate(`recovery.badi_plus_payment_checkout_sidebar_${item}.description`)}
                </Text>
              </Spacer>
            </Flex>
          </Spacer>
        );
      })}
    </Spacer>
  );
};

export default BadiPlusListingDetails;
